import PlanetListPop from "./planet.list";


export default PlanetListPop;